import { Input, Textarea, Image, Text, View, Radio, AreaSelect } from 'components';
import Base, { Config } from 'components/saleTool/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';
import { user } from 'modules/saleTool/store';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loading, Toast } from 'components/Modal';
import { parse } from 'modules/smartParse';


interface good {
  goods_type: number;
  goods_num?: number | '';
  sell_price?: number | '';
  true_price?: number | '';
}

interface State {
  data: {
    province?: string;
    city?: string;
    address: string;
    name: string;
    phone: string;
    goods: good[];
    other_price?: number | '';
    is_pay: number | '';
    pay_type: number | '';
    is_install: number | '';
    remark?: string
  };
  showProvince: boolean;
  ShowCity: boolean;
  loading: boolean;
  editing?: boolean;
  addressText?: string;
  // name: string;
  // password: string;
}

export default class OrderAdd extends Base<any> {
  public config: Config = {
    navigationBarTitleText: '新建订单'
  };

  public state: State = {
    data: {
      province:'',
      city:'',
      address:'',
      name:'',
      phone:'',
      goods:[
        {
          goods_type:1,  //普通版
          goods_num:'',
          sell_price:'',
          true_price:''
        },
        {
          goods_type:2,  //增强版
          goods_num:'',
          sell_price:'',
          true_price:''
        }
      ],
      other_price:'',  //手续费
      is_pay:0,  //是否支付
      pay_type:1,  //收款渠道  1微信，2微店，3到付
      is_install:0,  //上门安装
      remark:''
    },
    showProvince: false,
    ShowCity: false,
    loading: false,
    editing: false,
    addressText:''
  };

  public async didMount() {
    if(this.props.location.state && this.props.location.state.id){
      await this.getDetail()
      this.setState({
        editing:true
      })
    }else{
      // console.log("没有id")
    }
    
  }

  private link = url => {
    history.push(url);
  }

  private showLoading = () => {
    this.setState({
      loading:true
    })
  }
  private hideLoading = () => {
    this.setState({
      loading:false
    })
  }

  private compare = (property) => {
    return function(a,b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2
    }
  }

  private getDetail = async() => {
    this.showLoading()
    const res = await this.apiClient.base.orderListInfo({
      id:this.props.location.state.id
    })
    if(res.status == 10000){
      let goods = [
        {
          goods_type:1,
          goods_num:'',
          sell_price:'',
          true_price:''
        },
        {
          goods_type:2,
          goods_num:'',
          sell_price:'',
          true_price:''
        }
      ]
      goods = [...res.body.order_goods , ...goods]
      let obj = {}
      let cc = goods.reduce((cur:Array<any> , next) => {
          obj[next.goods_type] ? "" : obj[next.goods_type] = true && cur.push(next);
          return cur;
      },[])
      cc.sort(this.compare("goods_type"))
      // console.log(cc)

      let good = {
        goods:cc
      }

      let data = {...res.body,...good}
      let {create_time,order_goods,sell_info,sid,status,...params} = data
      
      this.setState({
        data: params
      })
    }
    this.hideLoading()
  }

  private valueChange = (name,e) => {
    // console.log(name,[name],name.indexOf('.'),e.target.value);

    if(name.indexOf('.') > -1){
      let data_name= name.split('.')[1];
      let val = e.target.value
      if(name == 'data.other_price'){
        val = Number(e.target.value)
      }
      let result = Object.assign({}, this.state.data, { [data_name]: val })
  　　this.setState({
        data: result
  　　})
    }else{
      this.setState({[name]:  e.target.value})
    }

  }

  private textareaChange = (name,e) => {
    // console.log("aa",name,e.target.value)
    this.setState({[name]:  e.target.value})
    // console.log(parse(e.target.value))
  }

  private textParse = () => {
    const { data , addressText } = this.state
    const result = parse(addressText)
    let name = result.name || '';
    let mobile = result.phone || result.mobile;
    let address = result.province + result.city + result.addr;
    // console.log(result)
    this.setState({
      data:{
        ...data,
        address,
        name,
        phone:mobile,
      }
    })
  }

  private goodsValueChange = (name,e) => {
    // console.log(name,[name],name.indexOf('.'),e.target.value);

    let data_type= name.split('.')[0];
    let data_name= name.split('.')[1];
    let goods = this.state.data.goods;
    let index = data_type == 'a'? 0:1;
    let val = e.target.value == '' ? '' : Number(e.target.value)
    goods = goods.map((item, _index) => _index == index ? {...item, [data_name]: val} : item)
    
    let result = Object.assign({}, this.state.data, { goods : goods })
　　this.setState({
      data: result
　　})

  }

  private radioFun = (name,index,e) => {
    // console.log(name,index)
    let result = Object.assign({}, this.state.data, { [name]: index})
    this.setState({
      data: result
　　})
  }

  private checkData = () => {
    const { data } = this.state;
    if(data.name == ''){
      toast.error("请输入客户姓名",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return false;
    }
    if(data.phone == ''){
      toast.error("请输入客户电话",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return false;
    }
    if(data.address == ''){
      toast.error("请输入收货地址",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return false;
    }
    return true;
  }

  private showSelectArea = type => {
    if (type == "province"){
      this.setState({
        showProvince: true,
        ShowCity: false
      })
    }else if (type == "city"){
      if(this.state.data.province == ''){
        toast.error("请先选择省份",{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
        return;
      }
      this.setState({
        showProvince: false,
        ShowCity: true
      })
    }
    
  }

  private changeCity = (name,val) => {
    console.log(name,val)
    
    if(name == 'province'){
      let result = Object.assign({}, this.state.data, { ['province']: val,['city']: '' })
      this.setState({
        showProvince: false,
        ShowCity: true,
        data: result
      })
    }
    if(name == 'city'){
      let result = Object.assign({}, this.state.data, { ['city']: val })
      this.setState({
        showProvince: false,
        ShowCity: false,
        data: result
      })
    }
    if(name == 'close'){
      this.setState({
        showProvince: false,
        ShowCity: false
      })
    }
  }

  private submit = async() => {
    // console.log(this.state.data);return;
    let that = this;
    const { data, editing } = this.state;
    if(!this.checkData()){return;}
    // console.log(data);
    this.showLoading()
    const res = editing? await this.apiClient.base.orderEdit(data)
                       : await this.apiClient.base.orderAdd(data)

    this.hideLoading()
    if(res.status == 10000){
      toast.info("保存成功",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      setTimeout(function(){
        that.link('/saleTool/main')
      },1000)
      
    }else{
      toast.error(res.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
  }


  public render() {
    const { data, showProvince, ShowCity, loading, editing, addressText } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        <Loading isOpen={loading} />
        <AreaSelect showProvince={showProvince} showCity={ShowCity} valueChange={this.changeCity} />
        <View className={styles.sec}>
          <Text className={styles.title}>客户信息</Text>
          <View className={styles.addressArea}>
            <View className={styles.taInner}>
              <Textarea 
                className={styles.ta}
                value={addressText}
                placeholder='输入或粘贴收货信息，自动识别姓名、电话、地址。 如“张三，13888888888，浙江省杭州市西湖区文一西路999号”'
                name="addressText"
                valueChange={this.textareaChange}
              />
              <View className={styles.taBtn}><Text className={styles.button} onClick={this.textParse}>智能识别</Text></View>
            </View>
          </View>
          <View className={styles.list}>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>客户姓名*</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.name}
                  name="data.name"
                  className={styles.input}
                  placeholder="请填写客户姓名"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>客户电话*</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.phone}
                  name="data.phone"
                  type="number"
                  className={styles.input}
                  placeholder="请填写客户手机号"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>收货地址*</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.address}
                  name="data.address"
                  className={styles.input}
                  placeholder="请填写详细地址"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
          </View>
        </View>
        <View className={styles.sec}>
          <Text className={styles.title}>商品信息</Text>
          <View className={styles.list}>
            <Text className={styles.tinyTitle}>标准版</Text>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>商品数量</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.goods[0].goods_num}
                  name="a.goods_num"
                  type="number"
                  className={styles.input}
                  placeholder="请填写数量"
                  valueChange={this.goodsValueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>出售价格</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.goods[0].sell_price}
                  name="a.sell_price"
                  type="number"
                  className={styles.input}
                  placeholder="请填写出售价格"
                  valueChange={this.goodsValueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>商品原价</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.goods[0].true_price}
                  name="a.true_price"
                  type="number"
                  className={styles.input}
                  placeholder="可不填"
                  valueChange={this.goodsValueChange}
                />
              </View>
            </View>
          </View>
          <View className={styles.list}>
            <Text className={styles.tinyTitle}>增强版</Text>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>商品数量</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.goods[1].goods_num}
                  name="b.goods_num"
                  type="number"
                  className={styles.input}
                  placeholder="请填写数量"
                  valueChange={this.goodsValueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>出售价格</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.goods[1].sell_price}
                  name="b.sell_price"
                  type="number"
                  className={styles.input}
                  placeholder="请填写出售价格"
                  valueChange={this.goodsValueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>商品原价</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.goods[1].true_price}
                  name="b.true_price"
                  type="number"
                  className={styles.input}
                  placeholder="可不填"
                  valueChange={this.goodsValueChange}
                />
              </View>
            </View>
          </View>
        </View>
        <View className={styles.sec}>
          <Text className={styles.title}>其他信息</Text>
          <View className={styles.list}>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>是否到账*</Text>
              <View className={styles.lis_r}>
                <Radio 
                  opt= {[
                    {
                      text:'未 到 账',
                      ind:0
                    },
                    {
                      text:'已 到 账',
                      ind:1
                    }
                  ]}
                  value = {data.is_pay}
                  name = "is_pay"
                  onClick={this.radioFun} 
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>到账渠道*</Text>
              <View className={styles.lis_r}>
                <Radio 
                  opt= {[
                    {
                      text:'微信转账',
                      ind:1
                    },
                    {
                      text:'微店下单',
                      ind:2
                    },
                    {
                      text:'到付',
                      ind:3
                    }
                  ]}
                  value = {data.pay_type}
                  name = "pay_type"
                  onClick={this.radioFun} 
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>上门安装*</Text>
              <View className={styles.lis_r}>
                <Radio 
                  opt= {[
                    {
                      text:'上门安装',
                      ind:1
                    },
                    {
                      text:'不需要上门',
                      ind:0
                    }
                  ]}
                  value = {data.is_install}
                  name = "is_install"
                  onClick={this.radioFun} 
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>其他费用</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.other_price}
                  name="data.other_price"
                  type="number"
                  className={styles.input}
                  placeholder="请填写"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>备注内容</Text>
              <View className={styles.lis_r}>
                <Input
                  value={data.remark}
                  name="data.remark"
                  className={styles.input}
                  placeholder="填写机型等备注信息"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
            
          </View>
        </View>

        {editing?(
          <View className={styles.edit} onClick={this.submit}>提交修改</View>
        ):(
          <View className={styles.submit} onClick={this.submit}>保存订单</View>
        )}
        

      </View>
    );
  }
}
